import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { Department } from '../../models/user-master/department';

@Injectable({
  providedIn: 'root',
})
export class DepartmentProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/department';

  public getAll(): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(this.baseUrl + '/all');
  }

  public getById(id: string): Observable<ApiResponse<Department>> {
    return this.httpClient.get<ApiResponse<Department>>(`${this.baseUrl}/${id}`);
  }

  public create(body: Department): Observable<ApiResponse<Department>> {
    return this.httpClient.post<ApiResponse<Department>>(this.baseUrl, body);
  }

  public update(body: Department): Observable<ApiResponse<Department>> {
    return this.httpClient.put<ApiResponse<Department>>(this.baseUrl, body);
  }

  public delete(id: string): Observable<ApiResponse<Department>> {
    return this.httpClient.delete<ApiResponse<Department>>(`${this.baseUrl}/${id}`);
  }

  public searchByMember(username: string): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/search-by-member?username=${encodeURIComponent(username)}`);
  }
}
